module.exports = __webpack_public_path__ + "static/scale-model-of-waterplace-park-in-providence-rhode-island-6db9ad2b14d4692985b0a51b5ee9e52f.png";